const stripeFallbackRequirementsBlocklist = ['external_account'];
export const stripeFallbackRequirementsBlocklistSet = new Set(stripeFallbackRequirementsBlocklist);
export const getHasPendingRequirements = ({
  currentlyDue,
  pastDue
}) => {
  const allRequirements = [...currentlyDue, ...pastDue];
  const allRequirementsFiltered = allRequirements.filter(element => !stripeFallbackRequirementsBlocklistSet.has(element));
  return !!allRequirementsFiltered.length;
};